const shots = [
  {
    src: "/img/condo-hallway.jpg",
    label: "Condo · Hallway",
    span: "sm:col-span-2",
  },
  {
    src: "/img/condo-kitchen.jpg",
    label: "Condo · Open Living",
  },
  {
    src: "/img/condo-bedroom.jpg",
    label: "Condo · Master Bedroom",
  },
  {
    src: "/img/condo-kitchen-dining.jpg",
    label: "Condo · Kitchen & Dining",
    span: "sm:col-span-2",
  },
  {
    src: "/img/condo-bunk-bedroom.jpg",
    label: "Condo · Bunk Bedroom",
  },
  {
    src: "/img/condo-vanity.jpg",
    label: "Condo · Bath Vanity",
  },
  {
    src: "/img/condo-shower.jpg",
    label: "Condo · Walk-In Shower",
    span: "sm:col-span-2",
  },
  {
    src: "/img/condo-spa-bath.jpg",
    label: "Condo · Soaking Tub",
    span: "sm:col-span-2",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="bg-[#FAFAFA] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">Recent Work</div>
            <h2 className="mt-3 font-heading font-black uppercase tracking-tight text-[#334155] text-4xl sm:text-5xl leading-[0.95]">
              From The Job Site.
            </h2>
          </div>
          <p className="max-w-md text-base text-[#4B5563]">
            A peek at recent projects across Bay County — painting, washing, and bringing
            properties back to brand-new.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-5 auto-rows-[200px] sm:auto-rows-[240px]">
          {shots.map((s, i) => (
            <figure
              key={i}
              className={`group relative overflow-hidden bg-[#334155] ${s.span || ""}`}
            >
              <img
                src={s.src}
                alt={s.label}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 p-3 sm:p-4 bg-gradient-to-t from-black/85 to-transparent text-white font-heading font-bold uppercase tracking-tight text-sm sm:text-base">
                {s.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
